import React, { useState } from 'react'
import Typography from '@material-ui/core/Typography'

import Catalogue from '.'
import { catalogue, catalogue as catData } from '../materialData'
import styles from './catalogue.module.scss'
import Loading from 'components/Global/Loading'

interface swatch {
  name: string
  hex: any
  type: string
  id: number
}

interface cat {
  name: string
  logo: string
  id: number
  swatches: swatch[]
  types: string[]
}

interface SelCat {
  name: string
  id: number
  logo: string
}
interface Sel {
  cat: SelCat
  swatch: swatch | undefined
}

const CatalogueWrapper = () => {
  const [catalogue, setCatalogue] = React.useState<cat[]>()
  const [selCat, setSelCat] = React.useState<SelCat>({
    name: catData[0].name,
    id: catData[0].id,
    logo: catData[0].logo,
  })
  const [sel, setSel] = React.useState<Sel>({
    cat: { name: catData[0].name, id: catData[0].id, logo: catData[0].logo },
    swatch: undefined,
  })

  React.useEffect(() => {
    setTimeout(() => {
      setCatalogue(catData)
    }, 100)
  }, [])

  return (
    <div style={{ height: '100%' }}>
      <div className={styles.sltCatWrapper}>
        <div
          style={{
            backgroundImage: `url(${sel.cat.logo})`,
          }}
          className={styles.sltCat}
        />
        <div className={styles.sltSwatchInfo}>
          <Typography className={styles.sltCatName} variant="subtitle2">
            {sel.cat.name}
          </Typography>

          {sel && sel.swatch !== undefined && (
            <>
              <Typography className={styles.sltSwatchName} variant="h6">
                {sel.swatch.name}
              </Typography>
              <Typography variant="subtitle2">{sel.swatch.type}</Typography>
            </>
          )}
        </div>
        {sel && sel.swatch !== undefined && (
          <div
            style={{
              backgroundColor: sel.swatch.hex,
            }}
            className={styles.sltColor}
          />
        )}
      </div>
      {catalogue ? (
        catalogue.map((c: cat) => (
          <Catalogue
            cat={c}
            active={selCat !== undefined && selCat.id === c.id}
            onClickFn={setSelCat}
            key={c.id}
            setSel={setSel}
          />
        ))
      ) : (
        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Loading />
        </div>
      )}
    </div>
  )
}

export default CatalogueWrapper
